import type { Application } from '@splinetool/runtime';
import React, {
  Suspense,
  forwardRef,
  useCallback,
  useRef,
  useState,
} from 'react';
import styled from 'styled-components';
import { IS_SPLINE_DISALLOWED } from '@/configs/devEnv/isSplineDisallowed';

const ReactSpline = React.lazy(() => import('@splinetool/react-spline'));

const Root = styled.div`
  position: relative;
`;
const Cover = styled.div<{ isLoaded?: boolean }>`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: ${({ theme }) => theme.colors.background};
  ${({ theme, isLoaded }) => theme.opacity[isLoaded ? 0 : 100]}
`;

export interface Props {
  url?: string;
  loadingNode?: React.ReactNode;
  variables?: Record<string, string | number | boolean>;
}

export default forwardRef<HTMLDivElement, Props>(function Spline(
  { url, loadingNode, ...props },
  ref
) {
  // ref
  const spline = useRef<Application>();

  // state
  const [isLoaded, setIsLoaded] = useState(false);

  // callback
  const handleLoad = useCallback((scene: Application) => {
    setIsLoaded(true);

    spline.current = scene;

    if (spline.current) {
      spline.current.setGlobalEvents(true);
    }
  }, []);

  return (
    <Root ref={ref} {...props}>
      {url && !IS_SPLINE_DISALLOWED && (
        <Suspense>
          <ReactSpline scene={url} onLoad={handleLoad} />
        </Suspense>
      )}
      <Cover isLoaded={isLoaded}>{loadingNode}</Cover>
    </Root>
  );
});
